export const normalizedTabs = (rawTabs) => {
  return (Array.isArray(rawTabs) ? rawTabs : [])
    .map((tab) => {
      const key = String(tab?.key || '').trim();
      const label = String(tab?.label || '').trim();

      if (key === '' || label === '') {
        return null;
      }

      return { key, label };
    })
    .filter(Boolean);
};
